<template>
  <section class="content">
    <DataTable :value="userLists" :paginator="true" 
    :rows="100" :filters="filters"  :rowsPerPageOptions="[100,500,1000]"
    class="p-datatable-responsive p-datatable-gridlines" data-key="id">
      <Column header="S.N">
        <template #body="slotProps">
          {{slotProps.index+1}}
        </template>
      </Column>
      <Column header="Name" field="name" :sortable="true" filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['name']" />
        </template>
      </Column>
      <Column header="Username" field="username" :sortable="true" filterMatchMode="contains">
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['username']" />
        </template>
      </Column>
       <Column header="Role" field="roleName" :sortable="true" filterMatchMode="contains">
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['roleName']" />
        </template>
      </Column>
      <!-- <Column header="Role" field="role" filterField="role" filterMatchMode="contains"/> -->
       <Column header="Status" field="status" :sortable="true" filterMatchMode="contains">
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['status']" />
        </template>
      </Column>
      <Column header="Action">
      <template #body="slotProps">
         <Button class="p-button-raised p-button-success" @click="openEditDialog(slotProps.data)" icon="pi pi-pencil"/>
         <Button class="p-button-raised p-button-danger" icon="pi pi-trash"
         @click="openDeleteDialog(slotProps.data.id)"/>
      </template>
      </Column>
     <template #empty>No record found</template>
    </DataTable>
    <Dialog @deleted="deleteUser" @cancel="cancel" v-model="dialogShow"/>
  </section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import InputText from 'primevue/inputtext'
import RadioButton from 'primevue/radiobutton'
import Button from 'primevue/button'
export default {
  name: 'userList',
  data () {
    return {
      dialogShow: false,
      userId: null,
      filters: {},
      status: 'ACTIVE'
    }
  },
  computed: {
    userLists() {
      return this.$store.state.users.userLists
    }
  },
  mounted() {
    this.userList()
  },
  methods: {
    async userList() {
      await this.$store.dispatch('loadUser')
    },
    async deleteUser(value) {
      if (value.trim() === '') {
        let message = {
          message: 'Delete reason cannot be empty',
          messageType: 'error'
        }
        this.$emit('delete-user', message)
        this.dialogShow = true
        return
      }
      let deleteReason = {
        userId: this.userId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteUser', deleteReason)
      if (resp.data.status === 'SUCCESS') {
        let message = {
          message: resp.data.message,
          messageType: 'success'
        }
        this.$emit('delete-user', message)
      } else {
        let message = {
          message: resp.data.message,
          messageType: 'warn'
        }
        this.$emit('delete-user', message)
      }
      this.closeDialog()
    },
    closeDialog() {
      this.dialogShow = false
    },
    openDeleteDialog(id) {
      this.dialogShow = !this.dialogShow
      this.userId = id
    },
    openEditDialog(data) {
      this.$emit('edit-user', data)
    },
    cancel(data) {
      this.dialogShow = false
    }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    InputText,
    Button,
    RadioButton
  }
}
</script>



// WEBPACK FOOTER //
// userList.vue?3e9d6f80